import Heading from './Heading';
import Text from './Text';
import Button from './Button';
import Image from './Image';
import ImageAndText from './ImageAndText';
import FAQ from './FAQ';
import Youtube from './Youtube';
import ContactForm from './ContactForm';

export default {
  heading: Heading,
  text: Text,
  button: Button,
  image: Image,
  imageAndText: ImageAndText,
  faq: FAQ,
  youtube: Youtube,
  contactForm: ContactForm,
};
